import { useMemo } from 'react';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import type { SelectOption } from '../../components/ui/SelectField';

/**
 * The admin list filters are nullable booleans: unset means "no filter", which
 * the API expects as null rather than false.
 */
export const triStateValue = (value: string): boolean | null => {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return null;
};

export const useTriStateOptions = (): readonly SelectOption[] => {
  const { t } = useTranslation('admin');

  return useMemo(
    () => [
      { value: '', label: t('common.all') },
      { value: 'true', label: t('common.yes') },
      { value: 'false', label: t('common.no') },
    ],
    [t],
  );
};
